// The dashboard card's element id, which the sidebar pill scrolls to.
export const CARD_ID = 'getting-started';
